import { AnyAction } from 'redux'

import {
  SET_EDIT_VENDOR_PRICING_AGREEMENT,
  CLEAR_EDIT_VENDOR_PRICING_AGREEMENT,
  SET_UNIVERSAL_VENDOR_PRICING_AGREEMENTS,
  SET_MARKET_VENDOR_PRICING_AGREEMENTS,
  SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENTS,
  SET_UNIVERSAL_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
  SET_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
  SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
} from '@actions/vendorPricingAgreements'

import { VendorPricingAgreement } from '@types'

const initialEditVendorPricingAgreementState: VendorPricingAgreement | null =
  null
const initialUniversalVendorPricingAgreementsState:
  | VendorPricingAgreement[]
  | null = null
const initialMarketVendorPricingAgreementsState:
  | VendorPricingAgreement[]
  | null = null
const initialVendorMarketVendorPricingAgreementsState:
  | VendorPricingAgreement[]
  | null = null

export const editVendorPricingAgreement = (
  state = initialEditVendorPricingAgreementState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_EDIT_VENDOR_PRICING_AGREEMENT:
      return action.payload
    case CLEAR_EDIT_VENDOR_PRICING_AGREEMENT:
      return null
    default:
      return state
  }
}

export const universalVendorPricingAgreements = (
  state = initialUniversalVendorPricingAgreementsState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_UNIVERSAL_VENDOR_PRICING_AGREEMENTS:
      return action.payload
    case SET_UNIVERSAL_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS:
      return updateAgreementInAgreements(state, action)
    default:
      return state
  }
}

export const marketVendorPricingAgreements = (
  state = initialMarketVendorPricingAgreementsState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_MARKET_VENDOR_PRICING_AGREEMENTS:
      return action.payload
    case SET_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS:
      return updateAgreementInAgreements(state, action)
    default:
      return state
  }
}

export const vendorMarketVendorPricingAgreements = (
  state = initialVendorMarketVendorPricingAgreementsState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENTS:
      return action.payload
    case SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS:
      return updateAgreementInAgreements(state, action)
    default:
      return state
  }
}

const updateAgreementInAgreements = (
  state: VendorPricingAgreement[] | null,
  action: AnyAction,
) => {
  const newState = (state || []).slice()
  const idx = newState.findIndex((o) => o.id === action.payload.id)
  if (idx !== -1) {
    newState.splice(idx, 1, action.payload)
  } else {
    newState.push(action.payload)
  }

  return newState
}
